import { allAnimals } from '../data/animalData';
import { formatProductionTime } from './productUtils';

export const RARITY_ORDER = {
  'Common': 0,
  'Uncommon': 1,
  'Rare': 2,
  'Epic': 3,
  'Legendary': 4
};

export function getFilteredAnimals(animalType) {
  if (!animalType) return [];
  return animalType.variants.flatMap(variant => 
    variant.rarity.map(rarity => ({
      id: `${variant.id}-${rarity.type.toLowerCase()}`,
      name: rarity.name || variant.name,
      variantName: variant.name,
      rarity: [rarity],
      productionTime: animalType.productionTime,
      product: animalType.product,
      image: rarity.image || variant.image,
      rarityType: rarity.type
    }))
  );
}

export function getRarityMultiplier(rarity) {
  switch(rarity.toLowerCase()) {
    case 'common': return 1;
    case 'uncommon': return 2;
    case 'rare': return 4;
    case 'epic': return 8;
    case 'legendary': return 16;
    default: return 1;
  }
}

const productInfo = {
  'Eggs': { 
    id: 'eggs', 
    image: 'egg',
    tabId: 'eggs',
    foodPath: '/food/birds',
    animalType: 'birds'
  },
  'Milk': { 
    id: 'milk', 
    image: 'milk',
    tabId: 'milk',
    foodPath: '/food/cattle',
    animalType: 'cattle'
  },
  'Wool': { 
    id: 'wool', 
    image: 'fuzzies',
    tabId: 'wool',
    foodPath: '/food/fuzzies',
    animalType: 'fuzzies'
  },
  'Truffle': { 
    id: 'truffle', 
    image: 'truffle',
    tabId: 'truffle',
    foodPath: '/food/piggies',
    animalType: 'piggies'
  }
};

export function getProductInfoForAnimal(animal) {
  // Map animal types to their product types using standardized keys
  const animalToProductMap = {
    'birds': 'Eggs',
    'cattle': 'Milk',
    'fuzzies': 'Wool',
    'piggies': 'Truffle'
  };
  // Extract base ID from animal ID (e.g., 'birds-common' -> 'birds')
  const baseId = animal.id.split('-')[0];
  const productType = animalToProductMap[baseId] || 'Eggs';
  return productInfo[productType];
}

export function getFoodInfoForAnimal(animal) {
  // Map animal types to their product types using standardized keys
  const animalToProductMap = {
    'birds': 'Eggs',
    'cattle': 'Milk',
    'fuzzies': 'Wool',
    'piggies': 'Truffle'
  };
  const baseId = animal.id.split('-')[0];
  const productType = animalToProductMap[baseId] || 'Eggs';
  const info = { ...productInfo[productType] };
  
  // Ensure the food path is correct for Piggies
  if (baseId === 'piggies') {
    info.foodPath = '/food/piggies';
  }
  
  return info;
}

// Debug log to check allAnimals keys
console.log('All animals keys:', Object.keys(allAnimals));

// Manually define the order of animal types to ensure consistency
const animalTypesOrder = ['birds', 'cattle', 'fuzzies', 'piggies'];

export const animalTypes = animalTypesOrder
  .filter(key => {
    const exists = key in allAnimals;
    console.log(`Checking ${key}:`, exists);
    return exists;
  })
  .map(key => {
    console.log(`Mapping ${key}:`, allAnimals[key]);
    return {
      id: key,
      name: allAnimals[key]?.name || key.charAt(0).toUpperCase() + key.slice(1),
      // Fuzzies and Piggies are stored in the beds directory, others in animals
      image: key === 'fuzzies' || key === 'piggies'
        ? `/images/beds/${key}/common/preview.png`
        : `/images/animals/${key}/common/preview.png`
    };
  });

console.log('Animal types:', animalTypes); // Debug log

export { formatProductionTime }; 